import React, { useState, useRef } from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Box, Button, FormHelperText } from "@mui/material";
import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { toast } from "react-toastify";

const FormProfileComponent = ({ formik, edited }) => {
  //   const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState(() =>
    edited
      ? formik.values.club_img
      : formik.values.club_img
        ? URL.createObjectURL(formik.values.club_img)
        : null,
  );
  const imageInputRef = useRef(null);

  const [error, setError] = useState(
    edited
      ? formik.values.club_img
        ? false
        : "Please select a Goal image"
      : "Please select Goal image",
  );

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      imgPreview == null && toast.error("Please select a file");
      // setError("Please select file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedImageFileTypes.includes(file.type) === false &&
      supportedImageFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      // setError("Please select a valid image file");
      return;
    }

    // setImg(URL.createObjectURL(file));
    setImgPreview(URL.createObjectURL(file));
    formik.setFieldValue("club_img", file);
    formik.setFieldTouched("club_img", true);
    // formik.validateField("club_img");
    formik.setFieldError("club_img", undefined);
    setError(false);
  };

  // console.log(
  //   formik.values.club_img,
  //   "formik.values.club_img",
  //   imgPreview,
  //   "preview image state"
  // );

  return (
    <>
      <Box className="formProfile">
        <input
          type="file"
          name="club_img"
          accept="image/*"
          onChange={handleChange}
          onBlur={formik.handleBlur}
          style={{ display: "none" }}
          ref={imageInputRef}
        />
        <Box className="option-outter" sx={{ padding: "0" }}>
          <div className="option-inner">
            <img
              src={imgPreview ? imgPreview : footbal}
              alt="football"
              className="img_fluid"
              style={imgPreview ? { objectFit: "cover" } : { opacity: "24%" }}
            />
          </div>
        </Box>

        <Button
          className="icon-wrapper"
          onClick={() => imageInputRef.current.click()}
        >
          <div className="img-div">
            <img src={cameraIcon} alt="camera" className="img_fluid" />
          </div>
        </Button>
      </Box>
      {/* {formik.errors.club_img && formik.touched.club_img ? (
        <FormHelperText sx={{ color: "red" }}>
          {formik.errors.club_img}
        </FormHelperText>
      ) : (
        ""
      )} */}

      {formik.submitCount > 0 && error ? (
        <FormHelperText sx={{ color: "red" }}>{error}</FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export default FormProfileComponent;
